// src/features/counter/counterSlice.js
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  open: false,
  drawerOpen: false,
  globalSearchText: "",
  navigations: [],
  refetchNav: false,
  internalRoutes: [],
  internalGroups: [],
};

export const navSlice = createSlice({
  name: "nav",
  initialState,
  reducers: {
    setOpen: (state, action) => {
      state.open = action.payload;
    },
    setDrawerOpen: (state, action) => {
      state.drawerOpen = action.payload;
    },
    setGlobalSearchText: (state, action) => {
      state.globalSearchText = action.payload;
    },
    setUserNavigations: (state, action) => {
      state.navigations = action.payload;
      state.refetchNav = false;
    },
    triggerRefetchNav: (state, action) => {
      state.refetchNav = action.payload;
    },
    setInternalRoutes: (state, action) => {
      state.internalRoutes = action.payload;
    },
    setInternalGroups: (state, action) => {
      state.internalGroups = action.payload;
    },
  },
});

export const {
  setOpen,
  setDrawerOpen,
  setGlobalSearchText,
  setUserNavigations,
  triggerRefetchNav,
  setInternalRoutes,
  setInternalGroups,
} = navSlice.actions;

export default navSlice.reducer;
